import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Beranda", href: "#home" },
  { label: "Layanan", href: "#services" },
  { label: "Tentang", href: "#about" },
  { label: "Keahlian", href: "#skills" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Blog", href: "/blog", external: true },
  { label: "Kontak", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("home");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const ids = ["home","about","skills","portfolio","certifications","contact"];
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.getElementById(ids[i]);
        if (el && window.scrollY >= el.offsetTop - 150) { setActive(ids[i]); break; }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = (href, external) => {
    setOpen(false);
    if (external) { window.location.href = href; return; }
    document.getElementById(href.replace("#",""))?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? "rgba(7,7,15,0.92)" : "transparent",
      backdropFilter: scrolled ? "blur(20px)" : "none",
      borderBottom: scrolled ? "1px solid rgba(255,255,255,0.05)" : "none",
      transition: "background 0.4s, border 0.4s",
    }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 32px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 72 }}>

          {/* Logo */}
          <a href="#home" onClick={e => { e.preventDefault(); nav("#home"); }}
            style={{ textDecoration: "none", display: "flex", alignItems: "baseline", gap: 2 }}>
            <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 22, color: "#f2f2ff", letterSpacing: "-1px" }}>EP</span>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#00e5ff", display: "inline-block", marginLeft: 3, marginBottom: 2 }} />
          </a>

          {/* Desktop Links */}
          <ul className="desktop-only" style={{ display: "flex", gap: 2, listStyle: "none", margin: 0, padding: 0, alignItems: "center" }}>
            {links.map(l => {
              const id = l.href.replace("#","");
              const isActive = active === id;
              return (
                <li key={l.label}>
                  <a href={l.href} onClick={e => { e.preventDefault(); nav(l.href, l.external); }}
                    style={{
                      display: "block", padding: "8px 16px", borderRadius: 6,
                      fontFamily: "'DM Sans', sans-serif", fontWeight: 500, fontSize: 14,
                      textDecoration: "none",
                      color: isActive ? "#f2f2ff" : "#6a6a88",
                      letterSpacing: "0.3px",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={e => { if (!isActive) e.target.style.color = "#c0c0d0"; }}
                    onMouseLeave={e => { if (!isActive) e.target.style.color = "#6a6a88"; }}
                  >
                    {l.label}
                    {isActive && <div style={{ height: 1, background: "linear-gradient(90deg, #00e5ff, #9b00ff)", marginTop: 2, borderRadius: 1 }} />}
                  </a>
                </li>
              );
            })}
          </ul>

          {/* CTA */}
          <a href="#contact" onClick={e => { e.preventDefault(); nav("#contact"); }}
            className="desktop-only"
            style={{
              padding: "9px 22px", borderRadius: 6,
              fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 13,
              textDecoration: "none", color: "#07070f",
              background: "linear-gradient(135deg, #00e5ff, #9b00ff)",
              letterSpacing: "0.5px",
              transition: "opacity 0.2s, transform 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = "0.85"; e.currentTarget.style.transform = "translateY(-1px)"; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "translateY(0)"; }}
          >
            KONTAK
          </a>

          {/* Mobile */}
          <button className="mobile-menu-btn" onClick={() => setOpen(!open)}
            style={{ background: "none", border: "none", color: "#f2f2ff", cursor: "none", padding: 8, display: "none" }}>
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Holographic line */}
      {scrolled && (
        <div style={{
          height: 1, background: "linear-gradient(90deg, transparent, #00e5ff, #9b00ff, #ff0099, transparent)",
          opacity: 0.4,
        }} />
      )}

      {/* Mobile menu */}
      {open && (
        <div style={{ background: "rgba(7,7,15,0.98)", backdropFilter: "blur(20px)", padding: "20px 32px 28px", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
          {links.map(l => (
            <a key={l.label} href={l.href} onClick={e => { e.preventDefault(); nav(l.href, l.external); }}
              style={{ display: "block", padding: "14px 0", fontFamily: "'Space Grotesk', sans-serif", fontWeight: 600, fontSize: 18, color: "#f2f2ff", textDecoration: "none", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              {l.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
